/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import headerConfig from '../config/header.config.json';
import loadingConfig from '../config/loading.config.json';
import errorConfig from '../config/error.config.json';
import notificationConfig from '../config/notifications.config.json';
import settingsConfig from '../config/settings.config.json';
import createSupplierConfig from '../config/createDistiller.config.json';

import { VApplication } from '@/application';
import { BreadcrumbService } from '../../../../services/breadcrumbService';
import { DEFAULT_APP_CONFIG } from '../../../../config/default.config';

import { templateReplacer } from '../../../../helpers/template.replace';

import { AppNavigatorService } from '../../../../AppNavigator';

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.AppNavigatorService') as AppNavigatorService;
};

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.BreadcrumbService') as BreadcrumbService;
};

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: {
        ...(this.getTransformedConfig(headerConfig) || {}),
        ...(breadcrumbItems || {}),
        // headerAction1:await this.getHeaderAction()
      },
      loading: this.getTransformedConfig(loadingConfig),
      notifications: this.getTransformedConfig(notificationConfig),
      error: this.getTransformedConfig(errorConfig),
      settings: this.getTransformedConfig(settingsConfig),
      createSupplier: this.getTransformedConfig(createSupplierConfig),
    };
  }

  private getTransformedConfig(data: any) {
    const _transformedConfig = templateReplacer(JSON.stringify(data), {
      holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
      holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
      holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
    });
    return JSON.parse(_transformedConfig);
  }
}
